import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import type { TrainingItem } from "@/types/training";

/**
 * Open the next task when the one being worked on gets done or skipped, not
 * whenever a settled task is open, so a skipped task can still be unskipped.
 */
export function useAdvanceOnSettle(items, expanded, next, setExpanded) {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Map();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const previousStatus = useRef(t0);
  let t1;
  let t2;
  if ($[1] !== expanded || $[2] !== items || $[3] !== next || $[4] !== setExpanded) {
    t1 = () => {
      if (!items) {
        return;
      }
      const before = previousStatus.current;
      const current = items.find(item => item.id === expanded);
      if (current && before.get(current.id) === "OPEN" && current.status !== "OPEN" && next) {
        setExpanded(next.id);
      }
      previousStatus.current = new Map(items.map(_temp));
    };
    t2 = [items, expanded, next, setExpanded];
    $[1] = expanded;
    $[2] = items;
    $[3] = next;
    $[4] = setExpanded;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
}
function _temp(item_0) {
  return [item_0.id, item_0.status];
}